import { useEffect } from 'react';
import { createPortal } from 'react-dom';

// Rende il modal direttamente in document.body via Portal
// Questo bypassa qualsiasi stacking context dei componenti parent
function Modal({ onClose, children, maxWidth = 520, centered = false }) {
  // Blocca lo scroll del body quando il modal è aperto
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, []);

  return createPortal(
    <div
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        zIndex: 9999,
        background: 'rgba(0,0,0,.82)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        display: 'flex',
        alignItems: centered ? 'center' : 'flex-start',
        justifyContent: 'center',
        padding: '20px',
        paddingTop: 'max(env(safe-area-inset-top), 20px)',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
      }}
      onClick={e => e.target === e.currentTarget && onClose && onClose()}
    >
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-border)',
          borderRadius: 20,
          width: '100%',
          maxWidth: maxWidth,
          padding: 28,
          boxShadow: '0 0 60px rgba(237,77,29,0.25)',
          animation: 'fadeUp .22s ease',
        }}
        onClick={e => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}

export default Modal;
